export default __webpack_public_path__ + "static/og-image-0072465d2e89720999c4d499b2661700.png";